export const AUTH_DATA_STORAGE_KEY = 'authData';
export const MODE_STORAGE_KEY = 'mode';
export const TUTORIAL_SHOW_STARTUP_STORAGE_KEY = 'tutorial-show-startup';
